import React, { Component, useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { EyeInvisibleOutlined,EyeOutlined } from '@ant-design/icons';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config'; 
import './auth.css';




const slide = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

const TOAST_OPTIONS = {
	position: "bottom-right",
	autoClose: 5000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
	theme: "colored",
};

// toastId keyed off the message: react-toastify ignores a toast whose id is
// already on screen, so repeat clicks can never stack the same message.
const notify = {
	success: (msg) => toast.success(msg, { ...TOAST_OPTIONS, toastId: `success-${msg}` }),
	error: (msg) => toast.error(msg, { ...TOAST_OPTIONS, toastId: `error-${msg}` }),
};



const Login = () => {

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const history = useHistory();
	const [visible, setVisible]= useState(true);
	const [loading, setLoading] = useState(false);
	// Ref, not state: it updates synchronously, so back-to-back clicks in the
	// same tick see the flag. `loading` alone is a render behind and lets them through.
	const isSubmitting = useRef(false);
  const [dataval, setdataval]= useState([]);


 const handleLeaveUpdate = async () => {
	  
			axios.post(API_BASE_URL +'/updateMonthlyLeaves')
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleLeaveUpdate();
		  }, []);



	const handleSubmit = (e) => {
		// setError(null);
		e.preventDefault();

		if (isSubmitting.current) {
			return;
		}

		if (!username.trim() || !password.trim()) {
			notify.error(!username.trim() ? "Please enter your username." : "Please enter your password.");
			return;
		}

		isSubmitting.current = true;
		setLoading(true);

		// alert(API_BASE_URL + '/login');
		axios.post(API_BASE_URL + '/login', { username: username, password: password }, { headers: { Accept: 'application/json' } }).then(response => {
			//console.log(response.data.accessToken);
			// 	console.log(response.data.message);
			// })
			console.log('Login successful:', response.data);
			var status = response.data.status;
			console.log(response.data.status);
			if (status == 200) {
				localStorage.setItem('authToken', response.data.accessToken);
        localStorage.setItem('employee_id', response.data.employee_id);
        localStorage.setItem('role_id', parseInt(response.data.role_id));
				// let token = response.data.accessToken;
				notify.success(response.data.message);

       

			  setTimeout(() => {

         const role = parseInt(response.data.role_id);

         console.log("ROLE:", role);
         
        if ([1,3,8].includes(role)) {
          history.push('/dashboard');
        } else {
          history.push('/employee-dashboard');
        }
          
        }, 3000);




				//   setTimeout(() => {
				// 	return history.push({
				// 		pathname: '/',
				// 		state: {
				// 		  data: token,
				// 		},
				// 	  })
				//   }, 3000);


				//setTimeout(()=> nav('/dashboard'),5000);

			} else if (status == 400) {
				notify.error(response.data.message);
			}

			if (status != 200) {
				isSubmitting.current = false;
				setLoading(false);
			}


		}).catch(err => {
  isSubmitting.current = false;
  setLoading(false);
  const res = err.response;
  if (!res) { notify.error('Network error'); return; }
  if (res.status === 422) {
    const errs = res.data?.errors || {};
    const firstMsg = Object.values(errs)[0]?.[0] || 'Validation failed';
    notify.error(firstMsg);
  } else {
    notify.error(res.data?.message || `Error ${res.status}`);
  }
});

	// 		const msg =
    //   error?.response?.data?.message ||
    //   error.message ||
    //   "Unexpected error occurred";

    // toast.error(msg, {
    //   position: "bottom-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    // });


			// toast.error(error.response.data.message, {
			// 	position: "bottom-right",
			// 	autoClose: 5000,
			// 	hideProgressBar: false,
			// 	closeOnClick: true,
			// 	pauseOnHover: true,
			// 	draggable: true,
			// 	progress: undefined,
			// 	theme: "colored",


			// 	});

		// });
	}



	return (
  <div className="auth login-wrapper d-flex justify-content-center align-items-center">
    <div className="card login-card-unified">
      <div className="row g-0">
        {/* LEFT: brochure/slider */}
        <div className="col-lg-6 p-4 d-flex align-items-center justify-content-center border-lg-end">
          <div className="w-100">
            <div className="carousel slide" data-ride="carousel" data-interval={3000}>
              <div className="carousel-inner rounded-3 overflow-hidden shadow-sm">
                {slide.map((s) => (
                  <div key={s} className={`carousel-item ${s === 1 ? 'active' : ''}`}>
                    <img
                      src={`assets/images/brochures/c${s}.jpeg`}
                      className="img-fluid w-100"
                      alt={`slide ${s}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: form */}
        <div className="col-lg-6 p-5">
          <div className="text-center mb-3">
            <Link className="header-brand" to="/">
              <img src="assets/images/pebble-hrm-logo.svg" width={150} alt="Pebble HRM" />
            </Link>
          </div>

          <h6 className="text-center text-muted mb-4">Login to your account</h6>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input
                  type={visible ? "password" : "text"}
                  className="form-control"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setVisible(!visible)}
                  aria-label="Toggle password visibility" style={{marginLeft: '5px'}}
                >
                  {visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary w-100" disabled={loading}>{loading ? "Logging in..." : "Click to login"}</button>
          </form>
        </div>
      </div>
    </div>

    <ToastContainer />
  </div>
);

}


export default Login;